import * as React from 'react';
import { connect } from 'react-redux';
import { flow } from 'lodash';
import appConfig from '../../../../config/main';
import Helmet from 'react-helmet';
import Header from './scenes/Header';
import Footer from './scenes/Footer';
import CookieAndPrivacy from './components/CookieAndPrivacy';
import { withRouter } from 'react-router';
import {IChannel, IPolicyApplication} from '../../data/api/models';
import {IStore} from '../../redux/IStore';

const mapStateToProps = (state: IStore) => ({
  selectedQuote: state.quote.application,
});

interface IShellProps {
  steps: object;
  channel: IChannel;
  selectedQuote: IPolicyApplication;
}

interface IShellState {
  hasUserAcceptCookies: boolean;
  hideContainer: boolean;
}

class Shell extends React.Component<IShellProps, IShellState> {
  public state = {
    hasUserAcceptCookies: false,
    hideContainer: false,
  };

  public constructor(props) {
    super(props);

    if (process.env.BROWSER) {
      const accepted: boolean = window.localStorage.getItem('eu-cookie-accepted') === 'true';

      this.state = {
        hasUserAcceptCookies: accepted,
        hideContainer: accepted,
      };
    }
  }

  private handleAcceptance = () => {
    this.setState({ hasUserAcceptCookies: true });

    window.localStorage.setItem('eu-cookie-accepted', 'true');

    setTimeout((() => {
      this.setState({ hideContainer: true });
    }), 700);
  }

  public render() {
    const { children, steps, channel } = this.props;
    const { hasUserAcceptCookies, hideContainer } = this.state;
    const favicon = channel.favicon;
    const imageType = favicon && favicon.substring(favicon.length - 3);
    const renderImageType = imageType === 'ico' ? 'x-icon' : imageType;

    const brandTemplate =  {
      titleTemplate: `${channel.baseName}: %s`,
    };

    const styles = [];
    const scripts = [];

    const dedicatedChannels = new Set([
      'fps-b2c',
      'fpr-b2c',
      'npo-b2c',
      'npor-b2c',
      'css-b2c',
      'cssr-b2c',
      'cspa-b2c',
      'cspar-b2c',
      'csis-b2c',
      'tpl-b2c',
      'camc-b2c',
    ]);

    const isProduction = process.env.NODE_ENV === 'production';
    const isDevOrLocal = ['local', 'development'].includes(process.env.NODE_ENV);

    const getAssetsForChannel = (key) => {
      if (!dedicatedChannels.has(key)) { return; }
      if (isProduction) {
        styles.push(`/public/css/${key}.css`);
      }
      if (isDevOrLocal) {
        scripts.push(`/public/js/${key}.js`);
      }
    };

    if (dedicatedChannels.has(channel.key)) {
      getAssetsForChannel(channel.key);
    } else if (['call-centre', 'pjh-b2b'].includes(channel.key)) {
      const key = this.props.selectedQuote.purchaseChannel;
      getAssetsForChannel(key);
    } else {
      styles.push('/public/css/dia-b2c.css');
      scripts.push('/public/js/dia-b2c.js');
    }

    const renderStyles = styles.map((src, i) =>
      <link key={i} rel="stylesheet" type="text/css" href={src} />,
    );

    const renderScripts = scripts.map((src, i) =>
      <script src={src} key={i} />,
    );

    return (
      <div>
        <Helmet {...appConfig.app.head} {...brandTemplate}>
          {channel.favicon && (
            <link
              rel="shortcut icon"
              type={`image/${renderImageType}`}
              href={channel.favicon}
            />
          )}
          {renderStyles}
          {renderScripts}
        </Helmet>
        {!hideContainer && (
          <div className={hasUserAcceptCookies ? 'fade-out' : ''}>
            <CookieAndPrivacy
                onClickEvent={this.handleAcceptance}
                channel={channel}
            />
          </div>
        )}
        <Header steps={steps} channel={channel} />
        {children}
        <Footer channel={channel} />
      </div>
    );
  }
}

export default flow([
  withRouter,
  connect(mapStateToProps),
])(Shell);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/index.tsx